import { ReactNode } from 'react';

interface PageFooterProps {
  left?: ReactNode;
  right?: ReactNode;
}

export function PageFooter({ left, right }: PageFooterProps) {
  return (
    <div className="border-t border-border bg-bg px-5 py-1.5 flex justify-between items-center font-mono text-[10.5px] text-text-3 flex-shrink-0">
      <div>{left}</div>
      <div>{right}</div>
    </div>
  );
}
